<template>
  <ListTransaction
    :scope-type="scopeType"
    :scope-id="scopeId"
    :key="scopeId"
  />
</template>

<script>
import ListTransaction from './ListTransaction.vue'

export default {
  name: 'AccountingIndex',
  components: { ListTransaction },
  computed: {
    scopeType() {
      return this.$route.meta.scopeType || 'global'
    },
    scopeId() {
      if (this.scopeType === 'pica-service') {
        return this.$route.params.picaServiceId
      } else if (this.scopeType === 'contract-manager') {
        return this.$route.params.contractManagerId
      }
      return null
    }
  }
}
</script>
